const PAYPAL_THEME = {
  "name": "paypal",
  "mode": "light",
  "sysSizeIconXs": "1.125rem",
  "sysSizeIconSm": "1.5rem",
  "sysSizeIconMd": "2rem",
  "sysSizeIconLg": "3rem",
  "sysSizeIconXl": "4rem",
  "sysSizePictogramSm": "6rem",
  "sysSizePictogramMd": "8.5rem",
  "sysSizePictogramLg": "10rem",
  "sysSizeCircleXs": "1.5rem",
  "sysSizeCircleSm": "2rem",
  "sysSizeCircleMd": "3rem",
  "sysSizeCircleLg": "4rem",
  "sysSizeCircleXl": "6rem",
  "sysSizeTapTargetXs": "2.5rem",
  "sysSizeTapTargetSm": "2.75rem",
  "sysSizeTapTargetDefault": "3rem",
  "sysSizeTapTargetLg": "4rem",
  "sysSizePointerWidthSm": "0.75rem",
  "sysSizePointerWidthLg": "1rem",
  "sysSizeIndicatorXs": "0.1875rem",
  "sysSizeIndicatorSm": "0.25rem",
  "sysSizeIndicatorMd": "0.375rem",
  "sysSizeIndicatorLg": "0.5rem",
  "sysSizeFieldSm": "3rem",
  "sysSizeFieldLg": "4rem",
  "sysSizeMediaXs": "22rem",
  "sysSizeMediaSm": "36rem",
  "sysSizeMediaMd": "47rem",
  "sysSizeMediaLg": "64rem",
  "sysSizeMediaXl": "72rem",
  "sysSizeMediaXxl": "90rem",
  "sysSpaceTiny": "0.125rem",
  "sysSpaceXs": "0.25rem",
  "sysSpaceSm": "0.5rem",
  "sysSpaceMd": "0.75rem",
  "sysSpaceLg": "1rem",
  "sysSpaceXl": "1.5rem",
  "sysSpaceJumbo": "2rem",
  "sysElevationLevel1Yoffset": "0.0625rem",
  "sysElevationLevel1Opacity": 0.08,
  "sysElevationLevel1Blur": "0.75rem",
  "sysElevationLevel2Yoffset": "0.125rem",
  "sysElevationLevel2Opacity": 0.1,
  "sysElevationLevel2Blur": "0.875rem",
  "sysElevationLevel3Yoffset": "0.125rem",
  "sysElevationLevel3Opacity": 0.1,
  "sysElevationLevel3Blur": "1.125rem",
  "sysElevationBlurCurve": 1,
  "sysElevationBlurSlope": -1,
  "sysElevationBlurBase": "0.625rem",
  "sysElevationOpacity": 0.15,
  "sysElevationBrightenFactor": 0.02,
  "sysElevationVerticalOffsetRatio": 1,
  "sysElevationHorizontalOffsetRatio": 0,
  "sysMotionTimingX1": 0,
  "sysMotionTimingY1": 0.9,
  "sysMotionTimingX2": 0.3,
  "sysMotionTimingY2": 1,
  "sysMotionDurationHover": "0.10s",
  "sysMotionDurationAction": "0.20s",
  "sysMotionDurationArrive": "0.50s",
  "sysMotionDurationDepart": "0.30s",
  "sysMotionDurationRepeat": "1.30s",
  "sysMotionDurationLinger": "7.00s",
  "sysBorderThicknessNormal": "0.0625rem",
  "sysBorderThicknessEmphasis": "0.125rem",
  "sysBorderThicknessFocus": "0.1875rem",
  "sysBorderThicknessFocusOutline": "0.375rem",
  "sysBorderRadiusXs": "0.125rem",
  "sysBorderRadiusSm": "0.25rem",
  "sysBorderRadiusMd": "0.5rem",
  "sysBorderRadiusLg": "0.75rem",
  "sysBorderRadiusInteractive": "50%",
  "sysTypographyDisplayFamily": "PayPalOpen-Regular",
  "sysTypographyDisplaySize": "4.5rem",
  "sysTypographyDisplayWeight": 400,
  "sysTypographyDisplayLineHeight": "4.875rem",
  "sysTypographyDisplayMaxScaleFactor": 1.25,
  "sysTypographyHeadingLgFamily": "PayPalOpen-Regular",
  "sysTypographyHeadingLgSize": "2.75rem",
  "sysTypographyHeadingLgWeight": 400,
  "sysTypographyHeadingLgLineHeight": "3rem",
  "sysTypographyHeadingLgMaxScaleFactor": 1.5,
  "sysTypographyHeadingSmFamily": "PayPalOpen-Regular",
  "sysTypographyHeadingSmSize": "1.75rem",
  "sysTypographyHeadingSmWeight": 400,
  "sysTypographyHeadingSmLineHeight": "2.25rem",
  "sysTypographyHeadingSmMaxScaleFactor": 1.5,
  "sysTypographyTitleStrongFamily": "PayPalOpen-Bold",
  "sysTypographyTitleStrongSize": "1.375rem",
  "sysTypographyTitleStrongWeight": 400,
  "sysTypographyTitleStrongLineHeight": "1.75rem",
  "sysTypographyTitleStrongMaxScaleFactor": 2,
  "sysTypographyTitleFamily": "PayPalOpen-Regular",
  "sysTypographyTitleSize": "1.375rem",
  "sysTypographyTitleWeight": 400,
  "sysTypographyTitleLineHeight": "1.75rem",
  "sysTypographyTitleMaxScaleFactor": 2,
  "sysTypographyBodyStrongFamily": "PayPalOpen-Bold",
  "sysTypographyBodyStrongSize": "1.125rem",
  "sysTypographyBodyStrongWeight": 400,
  "sysTypographyBodyStrongLineHeight": "1.5rem",
  "sysTypographyBodyStrongMaxScaleFactor": 2,
  "sysTypographyBodyFamily": "PayPalOpen-Regular",
  "sysTypographyBodySize": "1.125rem",
  "sysTypographyBodyWeight": 400,
  "sysTypographyBodyLineHeight": "1.5rem",
  "sysTypographyBodyMaxScaleFactor": 2,
  "sysTypographyCaptionStrongFamily": "PayPalOpen-Bold",
  "sysTypographyCaptionStrongSize": "0.875rem",
  "sysTypographyCaptionStrongWeight": 400,
  "sysTypographyCaptionStrongLineHeight": "1.25rem",
  "sysTypographyCaptionStrongMaxScaleFactor": 2,
  "sysTypographyCaptionFamily": "PayPalOpen-Regular",
  "sysTypographyCaptionSize": "0.875rem",
  "sysTypographyCaptionWeight": 400,
  "sysTypographyCaptionLineHeight": "1.25rem",
  "sysTypographyCaptionMaxScaleFactor": 2,
  "sysTypographyButtonLgFamily": "PayPalOpen-Bold",
  "sysTypographyButtonLgSize": "1.125rem",
  "sysTypographyButtonLgWeight": 400,
  "sysTypographyButtonLgLineHeight": "1.5rem",
  "sysTypographyButtonLgMaxScaleFactor": 2,
  "sysTypographyButtonSmFamily": "PayPalOpen-Bold",
  "sysTypographyButtonSmSize": "0.875rem",
  "sysTypographyButtonSmWeight": 400,
  "sysTypographyButtonSmLineHeight": "1.25rem",
  "sysTypographyButtonSmMaxScaleFactor": 2,
  "sysTypographyFieldLabelLgFamily": "PayPalOpen-Regular",
  "sysTypographyFieldLabelLgSize": "1.125rem",
  "sysTypographyFieldLabelLgWeight": 400,
  "sysTypographyFieldLabelLgLineHeight": "1.5rem",
  "sysTypographyFieldLabelLgMaxScaleFactor": 2,
  "sysTypographyFieldLabelSmFamily": "PayPalOpen-Regular",
  "sysTypographyFieldLabelSmSize": "0.875rem",
  "sysTypographyFieldLabelSmWeight": 400,
  "sysTypographyFieldLabelSmLineHeight": "1.25rem",
  "sysTypographyFieldLabelSmMaxScaleFactor": 2,
  "sysTypographyFieldValueXlFamily": "PayPalOpen-Regular",
  "sysTypographyFieldValueXlSize": "2.75rem",
  "sysTypographyFieldValueXlWeight": 400,
  "sysTypographyFieldValueXlLineHeight": "3rem",
  "sysTypographyFieldValueXlMaxScaleFactor": 1.5,
  "sysTypographyFieldValueLgFamily": "PayPalOpen-Regular",
  "sysTypographyFieldValueLgSize": "1.75rem",
  "sysTypographyFieldValueLgWeight": 400,
  "sysTypographyFieldValueLgLineHeight": "2.25rem",
  "sysTypographyFieldValueLgMaxScaleFactor": 2,
  "sysTypographyFieldValueSmFamily": "PayPalOpen-Regular",
  "sysTypographyFieldValueSmSize": "1.125rem",
  "sysTypographyFieldValueSmWeight": 400,
  "sysTypographyFieldValueSmLineHeight": "1.5rem",
  "sysTypographyFieldValueSmMaxScaleFactor": 2,
  "sysColorBackgroundMain": "#faf8f5",
  "sysColorBackgroundAlt": "#f1ede8",
  "sysColorBackgroundSurface": "#ffffff",
  "sysColorBackgroundSurfaceHover": "#faf8f5",
  "sysColorBackgroundSurfaceActive": "#f1ede8",
  "sysColorBackgroundHighContrast": "#001435",
  "sysColorBackgroundMediumContrast": "#545d68",
  "sysColorPrimaryMain": "#003087",
  "sysColorPrimaryMainHover": "#0070e0",
  "sysColorPrimaryMainActive": "#001c64",
  "sysColorPrimaryContrast": "#ffffff",
  "sysColorPrimaryContrastHover": "#b9effc",
  "sysColorPrimaryContrastActive": "#5bbbfc",
  "sysColorSecondaryMain": "#0070e0",
  "sysColorSecondaryMainHover": "#5bbbfc",
  "sysColorSecondaryMainActive": "#003087",
  "sysColorSecondaryContrast": "#ffffff",
  "sysColorTertiaryMain": "#faf8f5",
  "sysColorTertiaryMainHover": "#f1ede8",
  "sysColorTertiaryMainActive": "#e6e0d9",
  "sysColorTertiaryContrast": "#003087",
  "sysColorFeaturedMain": "#ffd140",
  "sysColorFeaturedMainHover": "#ffe888",
  "sysColorFeaturedMainActive": "#ff9100",
  "sysColorFeaturedContrast": "#003087",
  "sysColorUnselectedMain": "#e6e0d9",
  "sysColorUnselectedMainHover": "#faf8f5",
  "sysColorUnselectedMainActive": "#f1ede8",
  "sysColorUnselectedContrast": "#545d68",
  "sysColorSelectedMain": "#0070e0",
  "sysColorSelectedMainHover": "#5bbbfc",
  "sysColorSelectedMainActive": "#003087",
  "sysColorSelectedContrast": "#ffffff",
  "sysColorSelectedRangeMain": "#b9effc",
  "sysColorSelectedRangeMainHover": "#5bbbfc",
  "sysColorSelectedRangeMainActive": "#0070e0",
  "sysColorSelectedRangeContrast": "#003087",
  "sysColorLinkMain": "#0070e0",
  "sysColorLinkMainHover": "#003087",
  "sysColorLinkMainActive": "#003087",
  "sysColorLinkAlt": "#001435",
  "sysColorLinkAltHover": "#001435",
  "sysColorLinkAltActive": "#001435",
  "sysColorLinkContrast": "#ffffff",
  "sysColorLinkContrastHover": "#b9effc",
  "sysColorLinkContrastActive": "#5bbbfc",
  "sysColorOverlayMain": "rgba(0, 0, 0, 0.55)",
  "sysColorOverlayMainHover": "rgba(0, 0, 0, 0.4)",
  "sysColorOverlayMainActive": "rgba(0, 0, 0, 0.7)",
  "sysColorOverlayContrast": "#ffffff",
  "sysColorAccent1Main": "#003087",
  "sysColorAccent1Contrast": "#ffffff",
  "sysColorAccent2Main": "#e02d50",
  "sysColorAccent2Contrast": "#ffffff",
  "sysColorAccent3Main": "#388c00",
  "sysColorAccent3Contrast": "#ffffff",
  "sysColorAccent4Main": "#7252cc",
  "sysColorAccent4Contrast": "#ffffff",
  "sysColorErrorMain": "#c40b0b",
  "sysColorErrorMainHover": "#ff5a6d",
  "sysColorErrorMainActive": "#9b0021",
  "sysColorErrorContrast": "#ffffff",
  "sysColorWarningMain": "#ffbe4a",
  "sysColorWarningMainHover": "#ffe888",
  "sysColorWarningMainActive": "#ff9100",
  "sysColorWarningAlt": "#e85e00",
  "sysColorWarningContrast": "#001435",
  "sysColorSuccessMain": "#0f7013",
  "sysColorSuccessMainHover": "#6fc400",
  "sysColorSuccessMainActive": "#388c00",
  "sysColorSuccessContrast": "#ffffff",
  "sysColorSystemMain": "#001435",
  "sysColorSystemMainHover": "#929496",
  "sysColorSystemMainActive": "#545d68",
  "sysColorSystemContrast": "#ffffff",
  "sysColorInfoMain": "#e6e0d9",
  "sysColorInfoMainHover": "#faf8f5",
  "sysColorInfoMainActive": "#f1ede8",
  "sysColorInfoContrast": "#001435",
  "sysColorSpecialtyMain": "#7252cc",
  "sysColorSpecialtyMainHover": "#b976ff",
  "sysColorSpecialtyMainActive": "#24247f",
  "sysColorSpecialtyContrast": "#ffffff",
  "sysColorStructureBorderHighContrast": "#929496",
  "sysColorStructureBorderLowContrast": "rgba(0, 0, 0, 0.1)",
  "sysColorStructureDivider": "#f1ede8",
  "sysColorStructureFocus": "#097ff5",
  "sysColorStructureFocusOutline": "rgba(209, 229, 249, 0.9)",
  "sysColorStructureErrorOutline": "rgba(224, 45, 80, 0.16)",
  "sysColorStructureScrim": "rgba(0, 0, 0, 0.4)",
  "sysColorStructureShimmer": "#e6e0d9",
  "sysColorStructureShimmerInverse": "#545d68",
  "sysColorStructureSheen": "rgba(255, 255, 255, 0.7)",
  "sysColorStructureShadow": "#000000"
};

export { PAYPAL_THEME };
